import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { environment } from '../../environments/environment';

@Injectable()
export class PrintService {
  constructor(private http: Http) {}

  private baseurl = environment.apiBaseUrl;

  // save pre-defined package when enters in printing page
  savePackage(data) {
    const userId = localStorage.getItem('userId');
    return this.http
      .post(`${this.baseurl}/package/save`, { userId, data })
      .map((res: Response) => res.json());
  }

  // update custom package when click on save button in printing page
  updatePackage(data) {
    const userId = localStorage.getItem('userId');
    return this.http
      .post(`${this.baseurl}/package/update`, { userId, data })
      .map((res: Response) => res.json());
  }

  // get all pre-defined and custom packages from DB
  getPackage() {
    const userId = localStorage.getItem('userId');
    return this.http
      .post(`${this.baseurl}/package/get`, { userId })
      .map((res: Response) => res.json());
  }

  // remove only custom packages that are created by user
  removePackage(id) {
    return this.http
      .post(`${this.baseurl}/package/remove`, { id })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/print.service.ts